import { DeviceInfoReport } from './client-device-info.js';
import { ClientTrackingState } from './client-tracking-state.js';
import { FndnUserInfo } from './fndn-user-info.js';

export enum SupportRequestStatus {
    New = 'new',
    Open = 'open',
    Resolved = 'resolved',
    WontFix = 'wontfix'
}

export enum SupportRequestCategory {
    Objective = 'objective help',
    Devices = 'workshop devices',
    GameClient = 'game client',
    Bug = 'bug report',
    Networking = 'networking',
    Other = 'other'
}

export interface SupportRequestMinimal {
    id: string;
    title: string;
    email: string;
    // @typescript-to-gdscript-type: Iso8601Date
    created: string;
    // @typescript-to-gdscript-type: Iso8601Date
    updated: string;
    status: SupportRequestStatus;
    category: SupportRequestCategory;
}

export interface SupportRequestListItem extends SupportRequestMinimal {
    // duration user has been waiting
    waitingMs: number;
    // @typescript-to-gdscript-type: int
    comments: number;
    // @typescript-to-gdscript-type: Iso8601Date
    lastComment: string;
    event: string;
    // @typescript-to-gdscript-type: Iso8601Date
    eventDate: string;
    eventMode?: string;
    eventHost: string;
}

export interface SupportRequestComment {
    id: string;
    author: string;
    message: string;
    // @typescript-to-gdscript-type: Iso8601Date
    created: string;
}

/**
 * These properties don't get returned from the list api as they
 * may be really large
 */
export interface SupportRequest extends SupportRequestMinimal {
    description: string;
    sessionId: string;
}

// @typescript-to-gdscript-skip
export interface SupportRequestClientInfo {
    // @typescript-to-gdscript-type: int
    clientId?: number;
    teamId?: number;
    // @typescript-to-gdscript-type: int
    teamName?: string;
    userInfo?: FndnUserInfo;
    deviceInfoReport?: DeviceInfoReport;
    clientTrackingState?: ClientTrackingState;
}

export interface SupportRequestUpdate {
    id: string;
    sessionId: string;
    title: string;
    email: string;
    status: string;
    category: string;
    // person who made the update
    author: string;
    // if this field is missing it's a new request.
    updatedFields?: Record<keyof SupportRequest, [string, string]>;
    // @typescript-to-gdscript-type: Iso8601Date
    updated: string;
}

export interface SupportRequestCommentUpdate {
    id: string;
    sessionId: string;
    title: string;
    commentId: string;
    author: string;
    requestEmail: string;
    category: string;
    // @typescript-to-gdscript-type: Iso8601Date
    updated: string;
    summary: string;
}

// @typescript-to-gdscript-gd-impl
export type AnySupportRequestUpdate = SupportRequestUpdate | SupportRequestCommentUpdate;

export interface SruKey {
    id: string;
    commentId?: string;
    updated: string;
}
